
import * as netlifyRuntime$gQqhtxbKWW from 'C:/inetpub/gitlab-runner/navatel.ir-new-website/node_modules/@nuxt/image-edge/dist/runtime/providers/netlify'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "netlify",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['netlify']: { provider: netlifyRuntime$gQqhtxbKWW, defaults: {} }
}
        